<template>
  <svg
    :fill="color || '#000000'"
    width="100%"
    height="100%"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.19 16.005l7.869 7.868-2.129 2.129-9.996-9.997L19.937 6.002l2.127 2.129z"
    />
  </svg>
</template>
<script>
export default {
  props: ['color'],
};
</script>
